import { render, staticRenderFns } from "./AstroCalendarNote.vue?vue&type=template&id=3dcce84b&scoped=true&"
import script from "./AstroCalendarNote.vue?vue&type=script&lang=js&"
export * from "./AstroCalendarNote.vue?vue&type=script&lang=js&"
import style0 from "./AstroCalendarNote.vue?vue&type=style&index=0&id=3dcce84b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcce84b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dcce84b')) {
      api.createRecord('3dcce84b', component.options)
    } else {
      api.reload('3dcce84b', component.options)
    }
    module.hot.accept("./AstroCalendarNote.vue?vue&type=template&id=3dcce84b&scoped=true&", function () {
      api.rerender('3dcce84b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/共時曆/AstroCalendarNote.vue"
export default component.exports